export const getSupportersAmountLabel = (count, name) => {
    const title = count === 1 ? name : `${name}s`;
    return `${count} ${title} supporters`;
};
